import * as mixActions from './mixActions'

import { Button } from '@atd/rui-base.mui.button'
import { FormControl } from '@atd/rui-base.mui.form-control'
import { FormHelperText } from '@atd/rui-base.mui.form-helper-text'
import { IconButton } from '@atd/rui-base.mui.icon-button'
import { InputLabel } from '@atd/rui-base.mui.input-label'
import { MenuItem } from '@atd/rui-base.mui.menu-item'
import { Select } from '@atd/rui-base.mui.select'
import ValidatedTextField from '../commonComponents/validatedTextField'
import { selectIngredients, selectMixes } from './productReducer'

import AddIcon from '@mui/icons-material/Add'
import React from 'react'
import { RavenThemeScope, DIALOG_MENU_PROPS } from '../ravenV5Theme'
import { bindActionCreators } from 'redux'
import { checkProductLimits } from '../lib/ddiUnits'
import { connect } from 'react-redux'
import { ddiFromDdiAndEntryMode } from '../lib/ddiConversions'
import { getMenuItemsForProductDDI } from '../commonComponents/unitMenuItems'

function mapStateToProps(state, ownProps) {
    return {
        mixes: selectMixes(state),
        ingredients: selectIngredients(state),
        carriers: state.product.carriers,
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(mixActions, dispatch)
}

class MixIngredient extends React.Component {
    handleIngredientSelect = (event, index, value) => {
        if (value >= 0) {
            this.props.selectIngredient(this.props.data.id, value)
        }
        else {
            this.handleAddIngredient()
        }
    }
    handleTextChange = (event) => {
        this.props.setIngredientProperty(this.props.data.id, event.target.name, event.target.value)
    }
    handleUserDisplayUnit = (event, index, value) => {
        this.props.setIngredientProperty(this.props.data.id, 'userDisplayUnit', value)
    }
    handleDelete = event => {
        this.props.delete(this.props.data.id)
    }
    handleAddIngredient = () => {
        this.props.addIngredient(this.props.data.id)
    }

    createIngredientDropDownList = () => {
        const addButton = (
            <MenuItem value={-1} key={'new'} label={'Select an Ingredient'} name="newIngredient">
                <RavenThemeScope>
                    <Button variant="contained" color="primary" fullWidth onClick={this.handleAddIngredient} name="newIngredientButton"><AddIcon htmlColor="white" /></Button>
                </RavenThemeScope>
            </MenuItem>
        )

        const uniqueIngredients = [...new Map(this.props.ingredients.map((ing) => [ing.id, ing])).values()]

        return [
            addButton,
            ...uniqueIngredients.map((data) => {
                return <MenuItem key={data.id} value={data.id} name={data.id}>{data.name}</MenuItem>
            }),
        ]
    }

    getUnitMenuItems = () => {
        let ing = this.props.ingredients.find(ing => { return this.props.data.ingredientId === ing.id })
        if (ing === undefined) {
            ing = {ddiId: -1}
        }

        const ddi = ddiFromDdiAndEntryMode(ing.ddiId, this.props.mode)

        return getMenuItemsForProductDDI(ddi)
    }

    renderIngredientSelection = () => {
        // For new ingredient lines or ones still available in the standard list show a dropdown
        if (!this.props.data.ingredient ||
            this.props.ingredients.find(ing => { return this.props.data.ingredientId === ing.id })
        ) {
            const availIngredients = this.createIngredientDropDownList()

            return (
                <FormControl variant="standard" className="selectFieldInline" disabled={this.props.disabled} error={this.props.data.ingredientId <= 0}>
                    <InputLabel>Ingredient</InputLabel>
                    <Select
                        MenuProps={DIALOG_MENU_PROPS}
                        value={this.props.data.ingredientId > 0 ? this.props.data.ingredientId : ''}
                        onChange={(event) => this.handleIngredientSelect(event, null, event.target.value)}
                        label="Ingredient"
                        name="ingredientSelect"
                    >
                        {availIngredients}
                    </Select>
                    {this.props.data.ingredientId <= 0 && <FormHelperText>Required Field</FormHelperText>}
                </FormControl>
            )
        }

        // Otherwise we are in a mix edit with a deleted ingredient, but we still want
        // to show this information to the user.

        return (
            <ValidatedTextField
                className="textFieldInline"
                value={this.props.data.ingredient.name}
                errorText={!this.props.data.ingredient.name && 'Deleted Ingredient'}
                name="ingredientSelect"
                label="Archived Ingredient"
                disabled={true}
            />
        )
    }
    renderDelete = () => {
        if (!this.props.disabled) {
            return (
                <IconButton
                    className="ingredientDelete"
                    name="deleteMixIngredient"
                    onClick={this.handleDelete}>
                    <img className="standardIcon" src={`${process.env.PUBLIC_URL}/images/jobIcons/Job_DeleteBlack.svg`}/>
                </IconButton>
            )
        }
    }

    render() {
        const ingredientSelection = this.renderIngredientSelection()
        const units = this.getUnitMenuItems()
        const deleteButton = this.renderDelete()
        const errorText = checkProductLimits(this.props.data.displayQuantity, this.props.data.userDisplayUnit)

        return (
            <div className="mixFlex" name="mixIngredientRow">
                {ingredientSelection}
                <ValidatedTextField
                    label={this.props.mode === 'rateMode' ? 'Rate' : 'Amount'}
                    onChange={this.handleTextChange}
                    defaultValue={this.props.data.displayQuantity || ''}
                    className="flexSmall"
                    name="displayQuantity"
                    errorText={errorText}
                    disabled={this.props.disabled}
                />
                <FormControl variant="standard" className="unitSelectionInline" disabled={this.props.disabled} error={!this.props.data.userDisplayUnit}>
                    <Select
                        MenuProps={DIALOG_MENU_PROPS}
                        value={this.props.data.userDisplayUnit}
                        onChange={(event) => this.handleUserDisplayUnit(event, null, event.target.value)}
                        name="displayUnit"
                    >
                        {units}
                    </Select>
                </FormControl>
                {deleteButton}
            </div>
        )
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(MixIngredient)
